import { ButtonHTMLAttributes, ForwardedRef, ReactNode, forwardRef } from "react";

import cls from "./Button.module.scss";
import { classNames, Mods } from "shared/lib/classNames/classNames";
import { Loader } from "../Loader";

export type ButtonVariant = "primary" | "outline" | "filled" | "default" | "clear";
export type ButtonColor = "blue" | "light" | "purple" | "red";

export type ButtonSize = "small" | "medium" | "big";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    variant?: ButtonVariant;
    disabled?: boolean;
    children?: ReactNode;
    fullWidth?: boolean;
    isLoading?: boolean;
    size?: ButtonSize;
    color?: ButtonColor;
    halfWidth?: boolean;
    rounded?: boolean;
}

export const Button = forwardRef((props: ButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
    const {
        className,
        children,
        variant = "filled",
        disabled,
        fullWidth,
        isLoading,
        size = "big",
        color = "blue",
        halfWidth,
        rounded,
        ...otherProps
    } = props;

    const mods: Mods = {
        [cls.disabled]: disabled,
        [cls.fullWidth]: fullWidth,
        [cls.halfWidth]: halfWidth,
        [cls.rounded]: rounded,

        [cls.isLoading]: isLoading,
    };
    const addClass = [className, cls[variant], cls[size], cls[color]];

    const whiteLoader = variant === "filled" || color === "blue" || color === "red" || color === "purple";

    return (
        <button
            type="button"
            disabled={disabled || isLoading}
            className={classNames(cls.button, mods, addClass)}
            {...otherProps}
            ref={ref}
        >
            {children}
            {isLoading && <Loader size="small" variant={whiteLoader ? "white" : "normal"} />}
        </button>
    );
});
Button.displayName = "Button";
